/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.05.2018
 * Copyright: xdot GmbH 2018
 */

import React from 'external/react';

import { InlineView, wrapWithInlineFormComponent } from './InlineFormControl';
import { DataUtil, WYSIWYGEditor } from 'plugin/liferay-widgets-react-web';

import { Button, FormGroup, HelpBlock } from 'external/react-bootstrap';
import ItemDescription from './ItemDescription';

// eslint-disable-next-line react/prop-types
const DescriptionDisplay = ({ item, formValid, startEdit, ...rest }) => {

  let i = DataUtil.asItem(item);
  return (
    <InlineView startEdit={startEdit ? startEdit : undefined} {...rest}>
      {
        () => {
          return (
            <React.Fragment>
              <ItemDescription item={i}/>
            </React.Fragment>);
        }
      }
    </InlineView>
  );
};

// eslint-disable-next-line react/prop-types
const DescriptionEdit = ({
  value,
  type,
  propName,
  item,
  isSaving,
  isEdited,
  onChange,
  stopEdit,
  startEdit,
  cancel,
  submit,
  reset,
  formError,
  formValidation,
  formValid,
  children,
  formData,
  ...otherProps
}) => {
  const validateProps = formValidation ? { validationState: formValidation[propName] ? 'error' : null } : {};

  return (
    <FormGroup {...validateProps}>
      <WYSIWYGEditor
        placeholder="Beschreibung"
        value={formData.description}
        onChange={onChange}
      />


      <div className="button-box-v">
        <Button variant="primary" onClick={stopEdit}>Abbrechen</Button>
        <Button variant="primary" onClick={submit}>Speichern</Button>
      </div>
      {formValidation && formValidation[propName] ?
        <HelpBlock>{formValidation[propName]}</HelpBlock> : null}
    </FormGroup>);
};

const InlineDescriptionFormControl = wrapWithInlineFormComponent(DescriptionEdit, DescriptionDisplay);

export default InlineDescriptionFormControl;



// WEBPACK FOOTER //
// ./js/components/InlineDescriptionFormControl.jsx